import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { ThemeContext } from '../context/ThemeContext';
import { Bell, X, Share2, Gift } from 'lucide-react';
import { isAuthenticated } from '../services/auth';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const Pricing = () => {
  const { darkMode } = useContext(ThemeContext);
  const [showNotifyModal, setShowNotifyModal] = useState(false);
  const [notifyEmail, setNotifyEmail] = useState('');
  const [hasNotified, setHasNotified] = useState(false);


  return (
    <div className={`min-h-screen flex flex-col ${darkMode ? 'dark' : ''} bg-gray-50 dark:bg-gray-900`}>
      <Navbar />
      <div className="pt-16 px-4 sm:px-6 lg:px-8 flex-grow">
        <div className="max-w-[1440px] mx-auto py-10">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-6">Pricing</h1>
        
        {/* Free Trial Banner */}
        <div className="mb-12 bg-gradient-to-r from-green-50 to-emerald-50 dark:from-green-900/30 dark:to-emerald-900/30 p-6 rounded-lg border border-green-100 dark:border-green-800" id="free-trial">
          <div className="flex flex-col md:flex-row md:items-center justify-between">
            <div>
              <h2 className="text-green-800 dark:text-green-300 font-medium text-xl mb-2">
                Try Torque Free for 7 Days
              </h2>
              <p className="text-gray-600 dark:text-gray-300 text-sm max-w-2xl">
                Get full access to all premium features for a week. No credit card required to start your trial.
                Experience everything Torque has to offer with no commitment.
              </p>
            </div>
            <div className="mt-4 md:mt-0">
              <Link
                to="/register"
                className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
              >
                Start Free Trial
              </Link>
            </div>
          </div>
        </div>

        {/* Referral Program Banner - Commented out - keeping code for future use */}
        {/* <div className="mb-16">
          <div className="bg-gradient-to-r from-purple-500 to-pink-500 dark:from-purple-700 dark:to-pink-700 rounded-xl shadow-xl overflow-hidden">
            <div className="flex flex-col md:flex-row items-center">
              <div className="md:w-3/4 p-8 md:p-10">
                <div className="flex items-center mb-3">
                  <Share2 className="w-6 h-6 text-purple-100 mr-2" />
                  <h3 className="text-2xl font-bold text-white">Referral Program</h3>
                </div>
                <h4 className="text-xl font-bold text-white mb-3">
                  Refer 10 Friends, Get 2 Years Access FREE!
                </h4>
                <p className="text-purple-100 mb-4">
                  Share Torque Professional with friends and colleagues to earn rewards. For every 10 paying subscribers you refer, you'll receive 2 full years of Torque Professional access - completely free! Plus, your referrals get a free month when they sign up.
                </p>
                <Link
                  to="/account/referrals"
                  className="mt-2 bg-white text-purple-600 hover:bg-purple-50 px-6 py-2 rounded-md text-sm font-medium inline-flex items-center"
                >
                  <Share2 className="w-4 h-4 mr-2" />
                  Get Referral Link
                </Link>
              </div>
              <div className="md:w-1/4 p-6 flex items-center justify-center">
                <div className="bg-white/20 backdrop-blur-sm p-6 rounded-full">
                  <Gift className="w-16 h-16 text-white" />
                </div>
              </div>
            </div>
          </div>
        </div> */}

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 auto-rows-fr">
          {/* Professional Plan */}
          <div className="bg-white dark:bg-gray-700 rounded-lg shadow-xl overflow-hidden border-2 border-blue-500 flex flex-col h-full">
            <div className="bg-blue-500 py-2 text-center">
              <span className="text-white font-medium">TORQUE PROFESSIONAL</span>
            </div>
            <div className="p-6 border-b dark:border-gray-600">
              <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">Torque Professional</h3>
              <p className="text-gray-600 dark:text-gray-300 mb-4">
                Our flagship product provides a complete solution for your automotive service business. With one simple subscription, you get access to all our professional features:
              </p>

              {/* Subscription Options */}
              <div className="mb-4">
                <div className="bg-gray-100 dark:bg-gray-600 rounded-lg p-2 flex justify-between mb-2">
                  <span className="text-sm font-medium dark:text-gray-200">Monthly</span>
                  <span className="text-sm font-bold dark:text-white">$119.99/mo</span>
                </div>
                <div className="bg-gray-100 dark:bg-gray-600 rounded-lg p-2 flex justify-between mb-2">
                  <span className="text-sm font-medium dark:text-gray-200">3 Months</span>
                  <span className="text-sm font-bold dark:text-white">$109.99/mo <span className="text-green-500">Save $30</span></span>
                </div>
                <div className="bg-gray-100 dark:bg-gray-600 rounded-lg p-2 flex justify-between mb-2">
                  <span className="text-sm font-medium dark:text-gray-200">6 Months</span>
                  <span className="text-sm font-bold dark:text-white">$99.99/mo <span className="text-green-500">Save $120</span></span>
                </div>
                <div className="bg-blue-100 dark:bg-blue-800 rounded-lg p-2 flex justify-between">
                  <span className="text-sm font-medium dark:text-gray-200">Annual</span>
                  <span className="text-sm font-bold dark:text-white">$999/year <span className="text-green-500">Save $440</span></span>
                </div>
              </div>

              <div className="flex items-baseline">
                <span className="text-3xl font-bold text-gray-900 dark:text-white">Save up to 31%</span>
              </div>
              <div className="mt-2 text-sm text-gray-600 dark:text-gray-300">
                with annual subscription
              </div>
            </div>
            <div className="p-6 flex-grow flex flex-col">
              <ul className="space-y-4 flex-grow">
                <li className="flex items-center">
                  <svg className="w-5 h-5 text-green-500 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-gray-600 dark:text-gray-300">Single User License</span>
                </li>
                <li className="flex items-center">
                  <svg className="w-5 h-5 text-green-500 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-gray-600 dark:text-gray-300">Unlimited Invoices</span>
                </li>
                <li className="flex items-center">
                  <svg className="w-5 h-5 text-green-500 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-gray-600 dark:text-gray-300">Advanced Customer Management</span>
                </li>
                <li className="flex items-center">
                  <svg className="w-5 h-5 text-green-500 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-gray-600 dark:text-gray-300"><strong>Complete Vehicle Database</strong> with <strong>FREE yearly updates</strong></span>
                </li>
                <li className="flex items-center">
                  <svg className="w-5 h-5 text-green-500 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-gray-600 dark:text-gray-300">Comprehensive Reports and Analytics</span>
                </li>
                <li className="flex items-center">
                  <svg className="w-5 h-5 text-green-500 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-gray-600 dark:text-gray-300">Email Notifications and Reminders</span>
                </li>
                <li className="flex items-center">
                  <svg className="w-5 h-5 text-green-500 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-gray-600 dark:text-gray-300">Easy PDF Invoice Generation</span>
                </li>
              </ul>
              <Link 
                to={isAuthenticated() ? "/account/subscription" : "/login"}
                className="mt-8 w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-md text-sm font-medium inline-block text-center"
              >
                Subscribe Now
              </Link>
            </div>
          </div>

          {/* Cloud Version - Coming Soon */}
          <div className="bg-gradient-to-r from-blue-500 to-indigo-600 dark:from-blue-700 dark:to-indigo-800 rounded-lg shadow-xl overflow-hidden flex flex-col h-full">
            <div className="bg-blue-600 dark:bg-blue-800 py-2 text-center">
              <span className="text-white font-medium">COMING SOON</span>
            </div>
            <div className="p-6 border-b border-blue-500/30">
              <h3 className="text-2xl font-bold text-white mb-2">Torque Cloud</h3>
              <p className="text-blue-100 text-base mb-4">
                Access your business data anytime, anywhere with our cloud-connected version. Collaborate with your team in real-time and enjoy automatic backups and updates.
              </p>
              
              {/* Pricing Coming Soon */}
              <div className="bg-blue-500/20 backdrop-blur-sm rounded-lg p-4 mb-4">
                <div className="text-center">
                  <p className="text-xl font-bold text-white">Pricing will be announced soon</p>
                </div>
              </div>
            </div>
            <div className="p-6 text-white flex-grow flex flex-col">

              <div className="space-y-4 mb-6 flex-grow">
                <div className="flex items-center">
                  <div className="bg-blue-100 rounded-full p-1 mr-3 flex-shrink-0">
                    <svg className="w-4 h-4 text-blue-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <span>All Professional features included</span>
                </div>
                <div className="flex items-center ml-7">
                  <div className="bg-blue-100/50 rounded-full p-0.5 mr-3 flex-shrink-0">
                    <svg className="w-3 h-3 text-blue-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <span className="text-blue-100 text-sm">Unlimited Invoices</span>
                </div>
                <div className="flex items-center ml-7">
                  <div className="bg-blue-100/50 rounded-full p-0.5 mr-3 flex-shrink-0">
                    <svg className="w-3 h-3 text-blue-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <span className="text-blue-100 text-sm">Advanced Customer Management</span>
                </div>
                <div className="flex items-center ml-7">
                  <div className="bg-blue-100/50 rounded-full p-0.5 mr-3 flex-shrink-0">
                    <svg className="w-3 h-3 text-blue-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <span className="text-blue-100 text-sm">Complete Vehicle Database with FREE yearly updates</span>
                </div>
                <div className="flex items-center ml-7">
                  <div className="bg-blue-100/50 rounded-full p-0.5 mr-3 flex-shrink-0">
                    <svg className="w-3 h-3 text-blue-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <span className="text-blue-100 text-sm">Comprehensive Reports and Analytics</span>
                </div>
                <div className="flex items-center ml-7">
                  <div className="bg-blue-100/50 rounded-full p-0.5 mr-3 flex-shrink-0">
                    <svg className="w-3 h-3 text-blue-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <span className="text-blue-100 text-sm">Email Notifications and Reminders</span>
                </div>
                <div className="flex items-center ml-7">
                  <div className="bg-blue-100/50 rounded-full p-0.5 mr-3 flex-shrink-0">
                    <svg className="w-3 h-3 text-blue-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <span className="text-blue-100 text-sm">Easy PDF Invoice Generation</span>
                </div>
                <div className="flex items-center">
                  <div className="bg-blue-100 rounded-full p-1 mr-3 flex-shrink-0">
                    <svg className="w-4 h-4 text-blue-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <span>Unlimited Users</span>
                </div>
                <div className="flex items-center">
                  <div className="bg-blue-100 rounded-full p-1 mr-3 flex-shrink-0">
                    <svg className="w-4 h-4 text-blue-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <span>Cloud invoice storage and data sync</span>
                </div>
                <div className="flex items-center">
                  <div className="bg-blue-100 rounded-full p-1 mr-3 flex-shrink-0">
                    <svg className="w-4 h-4 text-blue-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <span>Real-time synchronization</span>
                </div>
                <div className="flex items-center">
                  <div className="bg-blue-100 rounded-full p-1 mr-3 flex-shrink-0">
                    <svg className="w-4 h-4 text-blue-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <span>Cross-device compatibility</span>
                </div>
                <div className="flex items-center">
                  <div className="bg-blue-100 rounded-full p-1 mr-3 flex-shrink-0">
                    <svg className="w-4 h-4 text-blue-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <span>Automatic cloud backups</span>
                </div>
              </div>

              <button
                className={`mt-8 w-full py-3 rounded-md text-sm font-medium inline-flex items-center justify-center ${
                  hasNotified 
                    ? 'bg-green-100 text-green-700 hover:bg-green-200' 
                    : 'bg-white text-indigo-600 hover:bg-indigo-50'
                }`}
                onClick={() => setShowNotifyModal(true)}
              >
                {hasNotified ? (
                  <>
                    <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    Thank You!
                  </>
                ) : (
                  <>
                    <Bell className="h-4 w-4 mr-2" />
                    Notify Me
                  </>
                )}
              </button>
            </div>
          </div>
        </div>

        </div>
      </div>
      
      {/* Notify Me Modal */}
      {showNotifyModal && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4">
          <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl max-w-md w-full p-6 relative transform transition-all">
            <button
              onClick={() => setShowNotifyModal(false)}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 dark:text-gray-500 dark:hover:text-gray-300"
            >
              <X className="w-5 h-5" />
            </button>
            
            <div className="text-center mb-6">
              <div className="w-16 h-16 bg-indigo-100 dark:bg-indigo-900/30 rounded-full flex items-center justify-center mx-auto mb-4">
                <Bell className="w-8 h-8 text-indigo-600 dark:text-indigo-400" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">Get Notified About Torque Cloud</h3>
              <p className="text-gray-600 dark:text-gray-300">
                Be the first to know when our cloud solution launches. Enter your email below and we'll keep you updated!
              </p>
            </div>
            
            {!hasNotified ? (
              <form onSubmit={(e) => {
                e.preventDefault();
                setHasNotified(true);
              }}>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Email Address
                </label>
                <input
                  type="email"
                  value={notifyEmail}
                  onChange={(e) => setNotifyEmail(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent dark:bg-gray-700 dark:text-white"
                  placeholder="your@email.com"
                  required
                />
              </div>
              
              <div className="flex gap-3">
                <button
                  type="button"
                  onClick={() => setShowNotifyModal(false)}
                  className="flex-1 px-4 py-2 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="flex-1 px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors flex items-center justify-center"
                >
                  <Bell className="w-4 h-4 mr-2" />
                  Notify Me
                </button>
              </div>
            </form>
            ) : (
              <div className="text-center">
                <div className="mb-6">
                  <div className="w-16 h-16 bg-green-100 dark:bg-green-900/30 rounded-full flex items-center justify-center mx-auto mb-4">
                    <svg className="w-8 h-8 text-green-600 dark:text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">Thank You!</h3>
                  <p className="text-gray-600 dark:text-gray-300">
                    We've added {notifyEmail} to our notification list. You'll be the first to know when Torque Cloud launches!
                  </p>
                </div>
                <button
                  onClick={() => {
                    setShowNotifyModal(false);
                  }}
                  className="px-6 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors"
                >
                  Close
                </button>
              </div>
            )}
          </div>
        </div>
      )}
      
      <Footer />
    </div>
  );
};

export default Pricing;